export default {
    // api: 'https://localhost:44307'
    api: 'https://carusage-backend.azurewebsites.net'
}



// WEBPACK FOOTER //
// ./src/config/index.js